export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    type: 'expand',
    width: 70,
    align: 'center',
    title: that.$l('INDEX.form_label_expand') || '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    title: that.$l('form_label_materialNo') || '包装编号',
    field: 'materialNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialName') || '包装名称',
    field: 'materialName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('form_label_materialSpec') || '包装规格',
    field: 'materialSpec',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_materialDisplayName') || '包装显示名称',
    field: 'materialDisplayName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_isSpecify') || '客户指定供应商',
    field: 'isSpecify',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true,
    slots:{
      default:"specifyslot"
    }
  },
  {
    title: that.$l('table_label_scmName') || '供应商名称',
    field: 'scmName',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_needQty') || '总需求数量',
    field: 'needQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_hasQty') || '已采购总数',
    field: 'hasQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_stockQty') || '已入库总数',
    field: 'stockQty',
    headerAlign: 'center',
    align: 'left',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人姓名',
    field: 'modifyByName',
    align: 'center',
    width: 100,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyDate',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
